// ゲーミングチェア: 高い背もたれとヘッドレスト、肘掛け付き
import { Box } from '@react-three/drei'

export default function GamingChairMesh({ width, height, depth, position, color, isSelected }) {
    // 高さ配分（合計100%）:
    // - 脚ベース: 5%
    // - 軸: 25%（調整可能部分）
    // - 座面: 5%
    // - 背もたれ: 55%（調整可能部分）
    // - ヘッドレスト: 10%

    const legBaseHeight = height * 0.05
    const shaftHeight = height * 0.25
    const seatHeight = height * 0.05  // 半分に
    const backHeight = height * 0.55
    const headrestHeight = height * 0.10
    const armrestHeight = height * 0.12

    // Y座標計算（下から積み上げ）
    const legBaseY = position[1] - height / 2 + legBaseHeight / 2
    const shaftY = position[1] - height / 2 + legBaseHeight + shaftHeight / 2
    const seatY = position[1] - height / 2 + legBaseHeight + shaftHeight + seatHeight / 2
    // 背もたれは座面のすぐ上から開始
    const backY = position[1] - height / 2 + legBaseHeight + shaftHeight + seatHeight + backHeight / 2
    // ヘッドレストは背もたれの上
    const headrestY = position[1] + height / 2 - headrestHeight / 2
    const armrestY = seatY + seatHeight / 2 + armrestHeight / 2

    return (
        <group>
            {/* 脚ベース */}
            <Box args={[width * 0.6, legBaseHeight, depth * 0.6]} position={[0, legBaseY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 軸（ガスシリンダー） */}
            <Box args={[width * 0.08, shaftHeight, depth * 0.08]} position={[0, shaftY, 0]}>
                <meshStandardMaterial color={color} metalness={0.5} roughness={0.3} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 座面 */}
            <Box args={[width * 0.8, seatHeight, depth * 0.8]} position={[0, seatY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 背もたれ */}
            <Box args={[width * 0.75, backHeight, depth * 0.1]} position={[0, backY, -depth * 0.4]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ヘッドレスト（別パーツ） */}
            <Box args={[width * 0.5, headrestHeight, depth * 0.12]} position={[0, headrestY, -depth * 0.4]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 肘掛け（左） */}
            <Box args={[width * 0.06, armrestHeight, depth * 0.5]} position={[-width * 0.45, armrestY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 肘掛け（右） */}
            <Box args={[width * 0.06, armrestHeight, depth * 0.5]} position={[width * 0.45, armrestY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 脚ベース */}
            <Box args={[width * 0.6, legBaseHeight, depth * 0.6]} position={[0, legBaseY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 軸 */}
            <Box args={[width * 0.08, shaftHeight, depth * 0.08]} position={[0, shaftY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 座面 */}
            <Box args={[width * 0.8, seatHeight, depth * 0.8]} position={[0, seatY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 背もたれ */}
            <Box args={[width * 0.75, backHeight, depth * 0.1]} position={[0, backY, -depth * 0.4]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - ヘッドレスト */}
            <Box args={[width * 0.5, headrestHeight, depth * 0.12]} position={[0, headrestY, -depth * 0.4]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 肘掛け（左） */}
            <Box args={[width * 0.06, armrestHeight, depth * 0.5]} position={[-width * 0.45, armrestY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 肘掛け（右） */}
            <Box args={[width * 0.06, armrestHeight, depth * 0.5]} position={[width * 0.45, armrestY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
